
import Component, { mixins } from 'vue-class-component';
import SizeGettersBase from '@/shared/app/ui/SizeGettersBase.vue';
import BaseDish from '@/shared/dish/ui/Dish.vue';
import { ORIGINS_ICONS } from '@/1001repas/origins/image';
import { EventBus } from '@/shared/app/connector/EventBus';

@Component
export default class Dish extends mixins(BaseDish, SizeGettersBase) {
  currAllergen = '';

  allergenChangeTimeout = 0;

  allergenTimeoutMs = 1800;

  mounted() {
    this.changeAllergen();
    EventBus.$on('change_allergen', this.changeAllergen);
  }

  beforeDestroy() {
    EventBus.$off('change_allergen', this.changeAllergen);
  }

  get dishStyle() {
    return {
      padding: this.config.padding?.toString() || '0',
    };
  }

  get nameStyle() {
    let size = 4 * this.rootFontsize * this.sizeFactor;
    if (this.name.length > 30) size *= 0.85;
    return {
      'font-size': `${size}px`,
    };
  }

  get priceStyle() {
    return {
      'font-size': `${2.5 * this.rootFontsize * this.sizeFactor}px`,
      padding: `${this.sizeFactor / 1.5}rem 0`,
      'background-color': this.config.priceBackgroundColorValue.toString(),
    };
  }

  get allergensStyle() {
    return {
      'font-size': `${2.4 * this.rootFontsize * this.sizeFactor}px`,
      padding: `${this.sizeFactor / 1.5}rem 0`,
    };
  }

  originStyle() {
    return {
      'max-height': `${Math.floor(100 / (this.originsImg.length + 1))}%`,
    };
  }

  get separatorStyle() {
    return {
      height: `${this.sizeFactor * 2}rem`,
    };
  }

  get originsImg() {
    return (this.origins?.toString() || '')
      .split(',')
      .map((originStr) => ORIGINS_ICONS[originStr])
      .filter((s) => s !== undefined);
  }

  changeAllergen() {
    const allergens = (this.allergens.toString() || '').split(',');
    if (!allergens || !allergens.length) {
      this.currAllergen = '';
    } else {
      let i = allergens.indexOf(this.currAllergen);
      i += 1; // 0 si -1 (non trouvé)
      if (i >= allergens.length) i = 0;
      this.currAllergen = allergens[i];
    }
  }

  get thinMode(): boolean {
    return this.height < this.rootFontsize * 5;
  }
}
